/*jshint unused: false, undef:false */

'use strict';

/**
 * Adapter for Webduct Orders
 *   Used to get information related to an order (e.g. order fulfillment statuses)
 *   
 * @version
 * 13.0.0 MLIBJS-153 Upgrade to font-awesome v6
 * 12.10.1 MLIBJS-139 Ecommerce job name/number override not displaying
 * 12.10.0 MLIBJS-137 Add order and fulfillment group parsing for manufacturing format
 * 12.7.0 MLIBJS-129 Add phase data when parsing orders for Order listings
 * 12.6.0 MLIBJS-127 Add PO Number to Parsed Order Details
 * 12.4.0 #756 MLIBJS-121 Add AdapterOrder into globalThis for ES6 usage
 * 12.0.5 #741 MLIBJS-111 Update 'parseOrders' function to include user group
 * 9.0.0 #701 MLIBJS-75 Remove deprecated services
 * 8.14.13 #696 MLIBJS-71 Cannot update ecom job numbers on order listing page
 * 8.14.7 #674 MLIBJS-50 When an order is placed 'On Hold' revert it to bold
 * 8.14.7 #672 MLIBJS-48 Error editing an order customer name or job number in listings
 * 8.14.6 #665 MLIBJS-41 Add Weight and Fabrication total to Parse Order
 * 8.14.6 #663 MLIBJS-39 Update Order Parsing to Include Job Phase ID
 * 8.14.6 #661 MLIBJS-37 Job Index doesn't display for Order Object
 * 8.14.6 #658 MLIBJS-34 Update order parsing to include lookahead fields
 * 8.14.5 #651 MLIBJS-27 Update Orders API calls in include order status
 * 8.14.3 #645 MLIBJS-21 ⁃ Add adjustments count to orders
 * 7.8.0 #513 Update Main Library for Job Override
 * 7.4.0 #467 Refactor parseOrderDetails from wdOrderService to AdapterOrder
 * 7.2.0 #449 Refactor wdOrder to wdOrderService
 * 5.4.0 #328 Add adapter for order fulfillment statuses
 *
 * @author Deitric Jang <djang@buildcentrix.com>
 * @author Erik Orozco <eorozco@intersog.com>
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 *
 * @copyright (c) 2016-2023 Build Centrix
 */
var AdapterOrder = function (api, wdSharedFunctionsService, wdStatusService, wdFulfillmentGroupService) {

    /**
     * Adapter
     *
     * This object is returned.
     *
     * @since 5.4.0
     *
     * @type {{}}
     */
    var adapter = {};

    /**
     * The base URL for api calls (e.g. ordering-api URL)
     *
     * @since 5.4.0
     *
     * @type {string}
     */
    var baseUrl = '';

    /**
     * Get order fulfillment statuses
     *
     * @since 5.4.0
     *
     * @returns {{}}
     */
    adapter.getStatuses = function()
    {
        var url = baseUrl + 'orders/fulfillment/statuses';
        return api.get(url);
    };

    /**
     * Set the base URL for api calls
     *
     * @since 5.4.0
     */
    adapter.setBaseUrl = function(url)
    {
        baseUrl = url;
    };

    /**
     * Parse Order Details
     * @since 7.4.0
     * @deprecated User Order Admin API
     *
     * @param {Object} order
     * @returns {Object}
     */
    adapter.parseOrderDetails =  function(order) {

        var result = {};

        var attached = order.attached;
        var dash = order;
        var dateCreated = wdSharedFunctionsService.getDescendantProperty(order.details, 'date_created');
        var dateRequired = wdSharedFunctionsService.getDescendantProperty(order.details, 'date_required');
        var dateProduction = wdSharedFunctionsService.getDescendantProperty(order.details, 'date_processed');
        var dateDelivery = wdSharedFunctionsService.getDescendantProperty(order.details, 'date_delivery');

        var createdDate = dateCreated ? new Date(dateCreated) : null;
        var requiredDate = dateRequired ? new Date(dateRequired) : null;
        var productionDate = dateProduction ? new Date(dateProduction) : null;
        var deliveryDate = dateDelivery ? new Date(dateDelivery) : null;

        var deliveryStatus = parseInt(wdSharedFunctionsService.getDescendantProperty(order.details, 'delivery_status_index'));
            deliveryStatus = deliveryStatus ? deliveryStatus : 1;
        var deliveryStatusDetails = wdSharedFunctionsService.getArrayObjectByKey(deliveryStatus, 'index', wdStatusService.deliveryStatuses);

        result.attached = attached;
        result.dash = dash;
        result.deliveryStatus = deliveryStatus;
        result.deliveryStatusDetails = deliveryStatusDetails;

        /*jshint camelcase: false */
        result.details = [
            {
                id: 'job-name',
                title: 'Job Name',
                value: order.job.name
            },
            {
                id: 'job-number',
                title: 'Job Number',
                value: order.job.number
            },
            {
                id: 'company',
                title: 'Company',
                value: order.group.name
            },
            {
                id: 'ordered-by',
                title: 'Ordered By',
                value: order.user.first_name + ' ' + order.user.last_name
            },
            {
                id: 'measured-by',
                title: 'Measured By',
                value: order.details.measured_by
            },
            {
                id: 'tag',
                title: 'Tag',
                value: order.details.tag_location
            },
            {
                id: 'po-number',
                title: 'PO Number',
                value: order.details.po_number
            }];

        result.orderIndex = order.idx;
        result.orderNumber = order.details.order_number;
        result.dates = [
            { id: 'date-ordered', icon: 'fa-regular fa-calendar', title: 'Ordered', value: createdDate },
            { id: 'date-requested', icon: 'fa-regular fa-calendar', title: 'Requested', value: requiredDate },
            { id: 'date-scheduled', icon: 'fa-regular fa-calendar', title: 'Production', value: productionDate },
            { id: 'date-delivery', icon: 'fa-regular fa-calendar', title: 'Delivery', value: deliveryDate }
        ];
        /*jshint camelcase: true */

        /*jshint camelcase: false */
        result.delivery = [
            {
                id: 'delivery',
                icon: 'fa-solid fa-truck',
                title: 'Delivery',
                value: order.details.delivery_instruction.label,
                address: order.address
            },
            {
                id: 'special-instructions',
                icon: 'fa-regular fa-comment',
                title: 'Special Instructions',
                value: order.details.instructions
            }
        ];
        /*jshint camelcase: true */

        return result;

    };

    /**
     * Parse and Standardise Orders for Display
     *
     * @since 7.2.0
     * 
     * @param {Array} orders
     * @returns {Array}
     */
    adapter.parseOrders = function(orders) 
    {
        var results = [];

        /* jshint camelcase: false */
        for (var i = 0; i < orders.length; i++) {

            var parsedOrder = {};
            var target = orders[i];

            var adjustments = target.adjustments;
            var attachments = target.attachments;
            var colour = 'transparent'; //Required to stop calendar "flashing"
            var companyName = wdSharedFunctionsService.getDescendantProperty(target, 'company.name');
            var fulfilmentStatus = wdSharedFunctionsService.getDescendantProperty(target, 'fulfilment_status');
            var deliveryStatus = parseInt(wdSharedFunctionsService.getDescendantProperty(target, 'delivery_status_index'));
            deliveryStatus = deliveryStatus ? deliveryStatus : 1;
            var deliveryStatusDetails = wdSharedFunctionsService.getArrayObjectByKey(deliveryStatus, 'index', wdStatusService.deliveryStatuses);
            var fulfillmentGroups = wdFulfillmentGroupService.parseFulfillmentGroups(fulfilmentStatus);

            var idx = wdSharedFunctionsService.getDescendantProperty(target, 'idx');

            // @todo 1. Fix Data Upstream to always return job.index (right now it does EITHER idx or index)
            // @todo 2. Rename Parsed Field to Job Index (it's not a Job ID) and fix the UI's which use it
            // @todo 3. Remove this hacky fix altogether. See https://webduct.atlassian.net/browse/MLIBJS-71
            var jobIdx = wdSharedFunctionsService.getDescendantProperty(target, 'job.idx');
            var jobIndex = wdSharedFunctionsService.getDescendantProperty(target, 'job.index');
            var jobId = jobIndex ? jobIndex : jobIdx;

            var jobName = wdSharedFunctionsService.getDescendantProperty(target, 'job.name');
            var jobNumber = wdSharedFunctionsService.getDescendantProperty(target, 'job.number');
            var jobPhaseId = wdSharedFunctionsService.getDescendantProperty(target, 'job.phase.id');
            var jobPhaseLabel = wdSharedFunctionsService.getDescendantProperty(target, 'job.phase.label');
            var ecommerceJob = wdSharedFunctionsService.getDescendantProperty(target, 'ecommerceJob');
            var orderNumber = wdSharedFunctionsService.getDescendantProperty(target, 'order_number');
            var userId = wdSharedFunctionsService.getDescendantProperty(target, 'user.idx');
            var userName = wdSharedFunctionsService.getDescendantProperty(target, 'user.name');
            var productionStatus = adapter.getOrderStatus(fulfilmentStatus);
            var productionStatusDetails = wdSharedFunctionsService.getArrayObjectByKey(productionStatus, 'index', wdStatusService.statuses);

            var dateCreated = wdSharedFunctionsService.getDescendantProperty(target, 'details.date_created');
            var dateRequired = wdSharedFunctionsService.getDescendantProperty(target, 'details.date_required');
            var dateProduction = wdSharedFunctionsService.getDescendantProperty(target, 'details.date_processed');
            var dateDelivery = wdSharedFunctionsService.getDescendantProperty(target, 'details.date_delivery');
            var poNumber = wdSharedFunctionsService.getDescendantProperty(target, 'details.po_number');

            var createdDate = wdSharedFunctionsService.parseStringToDate(dateCreated);
            var requiredDate = wdSharedFunctionsService.parseStringToDate(dateRequired);
            var productionDate = wdSharedFunctionsService.parseStringToDate(dateProduction);
            var deliveryDate = wdSharedFunctionsService.parseStringToDate(dateDelivery);

            var tag = wdSharedFunctionsService.getDescendantProperty(target, 'details.tag_location');
            var selected = false;
            var status = wdSharedFunctionsService.getDescendantProperty(target, 'status');
            var specialInstructions = wdSharedFunctionsService.getDescendantProperty(target, 'details.instructions');
            var rowClass = adapter.getRowClassByStatus(productionStatus);

            // Lookahead Specific
            var isLookahead = wdSharedFunctionsService.getDescendantProperty(target, 'details.lookahead.isLookaheadOrder');

            // Weight & Fabrication
            var totalWeight = wdSharedFunctionsService.getDescendantProperty(target, 'total_weight');
            var totalShopTime = wdSharedFunctionsService.getDescendantProperty(target, 'total_shop_labour_hour');

            // User Group a.k.a. Trade
            var userGroup =  target.userGroup && target.userGroup.length !== 0 ? wdSharedFunctionsService.getDescendantProperty(target, 'userGroup') : null;

            parsedOrder.adjustments = adjustments;
            parsedOrder.attachments = attachments;
            parsedOrder.class = rowClass;
            parsedOrder.color = colour;
            parsedOrder.companyName = companyName;
            parsedOrder.deliveryDate = deliveryDate;
            parsedOrder.deliveryStatus = deliveryStatus;
            parsedOrder.deliveryStatusDetails = deliveryStatusDetails;
            parsedOrder.fulfillmentGroups = fulfillmentGroups;
            parsedOrder.index = idx;
            parsedOrder.isLookahead = isLookahead;
            parsedOrder.jobId = jobId;
            parsedOrder.jobName = jobName;
            parsedOrder.jobNumber = jobNumber;
            parsedOrder.jobPhaseId = jobPhaseId;
            parsedOrder.jobPhaseLabel = jobPhaseLabel;
            parsedOrder.createdDate = createdDate;
            parsedOrder.deliveryDate = deliveryDate;
            parsedOrder.requiredDate = requiredDate;
            parsedOrder.orderNumber = orderNumber;
            parsedOrder.poNumber = poNumber;
            parsedOrder.productionDate = productionDate;
            parsedOrder.productionStatus = productionStatus;
            parsedOrder.productionStatusDetails = productionStatusDetails;
            parsedOrder.userId = userId;
            parsedOrder.userName = userName;
            parsedOrder.selected = selected;
            parsedOrder.start = productionDate;
            parsedOrder.status = status;
            parsedOrder.special = specialInstructions;
            parsedOrder.tag = tag;
            parsedOrder.totalShopTime = totalShopTime;
            parsedOrder.totalWeight = totalWeight;
            parsedOrder.userGroup = userGroup;

            if (ecommerceJob) {

                parsedOrder.ecommerceJob = ecommerceJob;

            }
            
            // Set Order Fabrication Times
            parsedOrder = adapter.buildFabricationTimesForOrder(parsedOrder);

            results.push(parsedOrder);
        }
        /* jshint camelcase: true */

        return results;
    };

    /**
     * Parse and Standardise Orders for Display (where the orders fetched are in the 'manufacturing' format)
     *
     * @since 12.10.0
     *
     * @param {Array} orders
     * @returns {Array}
     */
    adapter.parseOrdersManufacturing = function(orders)
    {
        var results = [];

        /* jshint camelcase: false */
        for (var i = 0; i < orders.length; i++) {

            var parsedOrder = {};
            var target = orders[i];

            var adjustments = target.adjustments;
            var attachments = target.attachments;
            var colour = 'transparent'; //Required to stop calendar "flashing"
            var companyName = wdSharedFunctionsService.getDescendantProperty(target, 'orderedFor.company.label');
            var orderFulfillmentGroups = wdSharedFunctionsService.getDescendantProperty(target, 'fulfillment.groups');
            var deliveryStatus = parseInt(wdSharedFunctionsService.getDescendantProperty(target, 'delivery.status.index'));
            deliveryStatus = deliveryStatus ? deliveryStatus : 1;
            var deliveryStatusDetails = wdSharedFunctionsService.getArrayObjectByKey(deliveryStatus, 'index', wdStatusService.deliveryStatuses);
            var fulfillmentGroups = wdFulfillmentGroupService.parseFulfillmentGroupsManufacturing(orderFulfillmentGroups);
            var idx = wdSharedFunctionsService.getDescendantProperty(target, 'index');
            var jobId = wdSharedFunctionsService.getDescendantProperty(target, 'job.index');
            var jobName = wdSharedFunctionsService.getDescendantProperty(target, 'job.name');
            var jobNumber = wdSharedFunctionsService.getDescendantProperty(target, 'job.number');
            var jobPhaseId = wdSharedFunctionsService.getDescendantProperty(target, 'job.phase.id');
            var jobPhaseLabel = wdSharedFunctionsService.getDescendantProperty(target, 'job.phase.label');
            var ecommerceJob = wdSharedFunctionsService.getDescendantProperty(target, 'job.override');
            var orderNumber = wdSharedFunctionsService.getDescendantProperty(target, 'number');
            var userId = wdSharedFunctionsService.getDescendantProperty(target, 'orderedFor.id');
            var userFirstName = wdSharedFunctionsService.getDescendantProperty(target, 'orderedFor.name.first');
            var userLastName = wdSharedFunctionsService.getDescendantProperty(target, 'orderedFor.name.last');
            var userName = userFirstName + ' ' + userLastName;
            var productionStatus = adapter.getOrderStatusManufacturing(fulfillmentGroups);
            var productionStatusDetails = wdSharedFunctionsService.getArrayObjectByKey(productionStatus, 'index', wdStatusService.statuses);

            var dateCreated = wdSharedFunctionsService.getDescendantProperty(target, 'ordered');
            var dateRequired = wdSharedFunctionsService.getDescendantProperty(target, 'requested');
            var dateProduction = wdSharedFunctionsService.getDescendantProperty(target, 'production.date');
            var dateDelivery = wdSharedFunctionsService.getDescendantProperty(target, 'delivery.date');
            var poNumber = wdSharedFunctionsService.getDescendantProperty(target, 'poNumber');

            var createdDate = new Date(dateCreated);
            var requiredDate = new Date(dateRequired);
            var productionDate = new Date(dateProduction);
            var deliveryDate = new Date(dateDelivery);

            var tag = wdSharedFunctionsService.getDescendantProperty(target, 'tag');
            var selected = false;
            var status = wdSharedFunctionsService.getDescendantProperty(target, 'status');

            var specialInstructions = wdSharedFunctionsService.getDescendantProperty(target, 'specialInstructions');
            var rowClass = adapter.getRowClassByStatus(productionStatus);

            // Lookahead Specific
            var isLookahead = wdSharedFunctionsService.getDescendantProperty(target, 'lookahead.isLookaheadOrder');

            // Weight & Fabrication
            var totalWeight = wdSharedFunctionsService.getDescendantProperty(target, 'calculations.totals.current.weight.value');
            var totalShopTime = wdSharedFunctionsService.getDescendantProperty(target, 'calculations.totals.current.shopLabour.value');

            // User Group a.k.a. Trade
            var userGroup =  target.userGroup && target.userGroup.length !== 0 ? wdSharedFunctionsService.getDescendantProperty(target, 'userGroup') : null;

            parsedOrder.adjustments = adjustments;
            parsedOrder.attachments = attachments;
            parsedOrder.class = rowClass;
            parsedOrder.color = colour;
            parsedOrder.companyName = companyName;
            parsedOrder.deliveryDate = deliveryDate;
            parsedOrder.deliveryStatus = deliveryStatus;
            parsedOrder.deliveryStatusDetails = deliveryStatusDetails;
            parsedOrder.fulfillmentGroups = fulfillmentGroups;
            parsedOrder.index = idx;
            parsedOrder.isLookahead = isLookahead;

            parsedOrder.jobPhaseId = jobPhaseId;
            parsedOrder.jobPhaseLabel = jobPhaseLabel;
            parsedOrder.createdDate = createdDate;
            parsedOrder.deliveryDate = deliveryDate;
            parsedOrder.requiredDate = requiredDate;
            parsedOrder.orderNumber = orderNumber;
            parsedOrder.poNumber = poNumber;
            parsedOrder.productionDate = productionDate;
            parsedOrder.productionStatus = productionStatus;
            parsedOrder.productionStatusDetails = productionStatusDetails;
            parsedOrder.userId = userId;
            parsedOrder.userName = userName;
            parsedOrder.selected = selected;
            parsedOrder.start = productionDate;
            parsedOrder.status = status;
            parsedOrder.special = specialInstructions;
            parsedOrder.tag = tag;
            parsedOrder.totalShopTime = totalShopTime;
            parsedOrder.totalWeight = totalWeight;
            parsedOrder.userGroup = userGroup;

            if (ecommerceJob) {
                parsedOrder.ecommerceJob = ecommerceJob;

                // For ecommerce orders, use the job override for job id, name, and number
                jobId = ecommerceJob.index;
                jobName = ecommerceJob.name;
                jobNumber = ecommerceJob.number;
            }
            parsedOrder.jobId = jobId;
            parsedOrder.jobName = jobName;
            parsedOrder.jobNumber = jobNumber;

            // Set Order Fabrication Times
            parsedOrder = adapter.buildFabricationTimesForOrder(parsedOrder);

            results.push(parsedOrder);
        }
        /* jshint camelcase: true */

        return results;
    };

    /**
     * Get Row Class by Status
     *
     * @since 7.2.0
     * 
     * @param {string} overallStatus
     * @returns {string}
     */
    adapter.getRowClassByStatus = function(overallStatus) 
    {
        var className = '';

        switch(overallStatus) {
            case 1:
                className = 'received-row';
                break;
            case 2:
                className = 'in-production-row';
                break;
            case 3:
                className = 'ready-row';
                break;
            case 4:
                className = 'shipped-row';
                break;
            case 5:
                className = 'cancelled-row';
                break;
            case 7:
                className = 'on-hold-row';
                break;
            default:
                break;
        }

        return className;
    };

    /**
     * Build Fabrication Times for Order
     *
     * @since 7.2.0
     * 
     * @param {object} order
     * @returns {*}
     */
    adapter.buildFabricationTimesForOrder = function(order) 
    {
        var remainingFabricationTimeFloat = adapter.calculateRemainingFabricationTimeAsFloat(order.fulfillmentGroups);
        var remainingFabricationTimeShort = wdSharedFunctionsService.convertFloatHoursToHoursAndMinutes(remainingFabricationTimeFloat, false);
        var remainingFabricationTimeLong = wdSharedFunctionsService.convertFloatHoursToHoursAndMinutes(remainingFabricationTimeFloat, true);

        var totalFabricationTimeFloat = adapter.calculateTotalFabricationTimeAsFloat(order.fulfillmentGroups);
        var totalFabricationTimeShort = wdSharedFunctionsService.convertFloatHoursToHoursAndMinutes(totalFabricationTimeFloat, false);
        var totalFabricationTimeLong = wdSharedFunctionsService.convertFloatHoursToHoursAndMinutes(totalFabricationTimeFloat, true);

        order.fabTimeRemainingFloat = remainingFabricationTimeFloat;
        order.fabTimeRemainingShort = remainingFabricationTimeShort;
        order.fabTimeRemainingLong = remainingFabricationTimeLong;
        order.fabTimeTotalFloat = totalFabricationTimeFloat;
        order.fabTimeTotalShort = totalFabricationTimeShort;
        order.fabTimeTotalLong = totalFabricationTimeLong;

        return order;
    };

    /**
     * Calculate the REMAINING Fabrication Times Based on (Parsed) Order Fulfilment Groups
     *
     * @since 7.2.0
     * 
     * @param {array} fulfillmentGroups
     * @returns {number}
     */
    adapter.calculateRemainingFabricationTimeAsFloat = function(fulfillmentGroups) 
    {
        var result = 0;

        for (var i = 0; i< fulfillmentGroups.length; i++) {

            var fulfillmentGroup = fulfillmentGroups[i];
            var filtered = !fulfillmentGroup.selected;
            var time = fulfillmentGroup.fabrication.float;
            var addToRemainder = wdStatusService.getStatusDetails(fulfillmentGroup.status).addToRemainingTime;

            if (addToRemainder && time && !filtered) {
                result += time;
            }
        }

        return result;
    };

    /**
     * Calculate the TOTAL fabrication Time Based on (Parsed) Order Fulfilment Groups
     *
     * @since 7.2.0
     *
     * @param {array} fulfillmentGroups
     * @returns {number}
     */
    adapter.calculateTotalFabricationTimeAsFloat = function(fulfillmentGroups)
    {
        var result = 0;

        for (var i = 0; i< fulfillmentGroups.length; i++) {

            var fulfillmentGroup = fulfillmentGroups[i];
            var filtered = !fulfillmentGroup.selected;
            var time = fulfillmentGroup.fabrication.float;
            var addToTotal = wdStatusService.getStatusDetails(fulfillmentGroup.status).addToTotalTime;

            if (addToTotal && time && !filtered) {
                result += time;
            }
        }

        return result;
    };

    /**
     * Get Overall Status based on Fulfilment Groups
     *
     * @since 7.2.0
     * 
     * @param {Object} fulfillmentGroups
     * @returns {Number} overallStatus
     */
    adapter.getOrderStatus = function(fulfillmentGroups) 
    {
        var overallStatus = 1;
        var fgStatusValues = [];
        var parsedFulfillmentGroups = wdFulfillmentGroupService.parseFulfillmentGroups(fulfillmentGroups);

        //Create an Array of Fulfillment Status Values for use in Logic
        for (var fg in parsedFulfillmentGroups) {

            /* istanbul ignore else */
            if (parsedFulfillmentGroups.hasOwnProperty(fg)){

                if (parsedFulfillmentGroups[fg].status !== 0) {

                    fgStatusValues.push(parsedFulfillmentGroups[fg].status);

                }
            }
        }

        //Strip away array duplicates
        fgStatusValues = wdSharedFunctionsService.removeArrayDuplicates(fgStatusValues);

        //The status list when ignoring cancelled items
        var fgStatusListNoCancel = fgStatusValues.filter(
            function (e)
            {
                return e !== 5;
            }
        );

        // CASE: No Fulfillment Groups - Default to NOT STARTED
        if (fgStatusValues.length === 0) {
            overallStatus = 1; // Not Started
        }
        // CASE: All Fulfilment Groups Have the same Status - Set Overall Status to be the Same
        else if (fgStatusValues.length === 1) {
            overallStatus = fgStatusValues[0];
        }
        //But if all fulfilment status are the same when we ignore cancelled: so is the overall status
        else {
            if (fgStatusListNoCancel.length === 1) {
                overallStatus = fgStatusListNoCancel[0];
            }
            //If any fulfilment status is Partially Shipped: The overall order is Partially Shipped
            //If any fulfilment status is In Production: The overall order is In Production
            else {
                if (fgStatusValues.indexOf(6) > -1) { // 6 = Partially Shipped
                    overallStatus = 6;
                }
                else if (fgStatusValues.indexOf(2) > -1) { // 2 = In Production
                    overallStatus = 2;
                }
                //If the fulfilment status values are all different and it's not in production, default to the lowest state
                else {
                    overallStatus = Math.min.apply(null, fgStatusValues);
                }
            }
        }

        return overallStatus;
    };

    /**
     * Get Overall Status based on Fulfilment Groups (for orders returned in the 'manufacturing' format)
     *
     * @since 12.10.0
     *
     * @param {Object} fulfillmentGroups
     * @returns {Number} overallStatus
     */
    adapter.getOrderStatusManufacturing = function(fulfillmentGroups)
    {
        var fgStatusValues = [];
        var parsedFulfillmentGroups = fulfillmentGroups;

        // Create an Array of Fulfillment Status Values for use in Logic
        for (var index in parsedFulfillmentGroups) {

            /* istanbul ignore else */
            if (parsedFulfillmentGroups[index].status !== 0) {

                fgStatusValues.push(parsedFulfillmentGroups[index].status);

            }
        }

        // Calculate the overall fulfillment status for the order from the fulfillment group statuses
        return adapter.calculateOverallStatus(fgStatusValues);
    };

    /**
     * Takes as input a list of fulfillment group statuses and calculates a single status for the entire order
     *
     * @since 12.10.0
     *
     * @param {Array} fgStatusValues A list of fulfillment group status indexes for an order
     * @return {Number} Returns a status index for the order
     */
    adapter.calculateOverallStatus = function(fgStatusValues)
    {
        var overallStatus = 1;

        // Strip away array duplicates
        fgStatusValues = wdSharedFunctionsService.removeArrayDuplicates(fgStatusValues);

        // The status list when ignoring cancelled items
        var fgStatusListNoCancel = fgStatusValues.filter(
            function (e)
            {
                return e !== 5;
            }
        );

        if (fgStatusValues.length === 0) {
            // CASE: No Fulfillment Groups - Default to NOT STARTED
            overallStatus = 1; // Not Started
        } else if (fgStatusValues.length === 1) {
            // CASE: All Fulfillment Groups Have the same Status - Set Overall Status to be the Same
            overallStatus = fgStatusValues[0];
        } else {
            // But if all fulfillment status are the same when we ignore cancelled: so is the overall status
            if (fgStatusListNoCancel.length === 1) {
                overallStatus = fgStatusListNoCancel[0];
            } else {
                // If any fulfillment status is Partially Shipped: The overall order is Partially Shipped
                // If any fulfillment status is In Production: The overall order is In Production

                if (fgStatusValues.indexOf(6) > -1) { // 6 = Partially Shipped
                    overallStatus = 6;
                } else if (fgStatusValues.indexOf(2) > -1) { // 2 = In Production
                    overallStatus = 2;
                } else {
                    // If the fulfillment status values are all different and it's not in production, default to the lowest state
                    overallStatus = Math.min.apply(null, fgStatusValues);
                }
            }
        }

        return overallStatus;
    };

    return adapter;
};
globalThis.AdapterOrder = AdapterOrder;
// EOF
